import { safeWindow } from './window.ts';

export const prgResolver = (prgHash: string): string => {
  const win = safeWindow();
  if (win) {
    win.location.href = atob(prgHash);
  }

  return prgHash;
};

export const prgLink = (url: string): string => {
  const prgHash = btoa(url);

  return prgResolver(prgHash);
};
